/**
 * Format a duration in seconds as an hh::mm:ss string.
 *
 * @param    {Number}   duration  The duration in seconds
 * @returns  {String}   The formatted duration.
 * @throws   Throws an error if the requested language isn't supported
 */
module.exports = function(duration) {
    var hours,
        minutes,
        seconds,
        parts = [],
        i,
        formattedDuration;

    hours   = Math.floor(duration / 3600);
    minutes = Math.floor((duration % 3600) / 60);
    seconds = duration % 60;

    // Add hours to the parts array only if there are any hours.
    if (hours > 0) {
        parts.push(hours);
    }

    // Add minutes and seconds to the parts array.
    parts.push(minutes);
    parts.push(seconds);

    // Format the parts, zero-padding all parts except the first one.
    for (i = 0; i < parts.length; i++) {
        if (i === 0) {
            // The first part, do not pad.
            parts[i] = parts[i].toString();
        }
        else {
            // For subsequent parts, pad with leading zeros if necessary.
            parts[i] = parts[i] < 10 ? "0" + parts[i] : parts[i].toString();
        }
    }

    // Concatenate
    formattedDuration = parts.join(":");

    return formattedDuration;
};
